import { Check, MessageCircle, Truck, ShieldCheck } from "lucide-react";
import { Reveal } from "../landing/shared";
import { SITE, waLink } from "@/config";

const INCLUDES = ["Premium Footstool", "FREE Doctor Counselling", "FREE Digital Guide"];

const Offer = () => (
  <section id="offer" data-testid="offer-section" className="relative overflow-hidden bg-navy py-16 sm:py-24">
    <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full border border-gold/15" aria-hidden="true" />
    <div className="pointer-events-none absolute -bottom-32 -left-24 h-96 w-96 rounded-full border border-gold/10" aria-hidden="true" />
    <div className="relative mx-auto max-w-2xl px-4 text-center sm:px-6">
      <Reveal>
        <p className="text-xs font-extrabold uppercase tracking-[0.25em]" data-testid="offer-brand-line">
          <span className="text-ivory">MEDLINK</span>
          <span className="text-gold">X</span>{" "}
          <span className="text-gold">{SITE.kitName}</span>
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-4 font-serif text-4xl leading-[1.08] tracking-tight text-ivory sm:text-5xl" data-testid="offer-headline">
          Start With <em className="italic text-gold-soft">One Small Change.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.14}>
        <p className="mt-6 font-serif text-6xl font-semibold text-gold-soft sm:text-7xl" data-testid="offer-price">
          {SITE.price}
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <ul className="mx-auto mt-7 flex max-w-xs flex-col items-start gap-3 text-left" data-testid="offer-includes-list">
          {INCLUDES.map((t, i) => (
            <li key={t} className="flex items-center gap-3" data-testid={`offer-include-${i + 1}`}>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold/15">
                <Check className="h-3.5 w-3.5 text-gold" strokeWidth={3} />
              </span>
              <span className={`text-base ${i > 0 ? "font-semibold text-gold-soft" : "text-ivory/90"}`}>{t}</span>
            </li>
          ))}
        </ul>
      </Reveal>
      <Reveal delay={0.26} className="mt-9">
        <a
          data-testid="offer-buy-now-button"
          href={SITE.razorpayUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex w-full items-center justify-center rounded-full bg-gold px-10 py-5 text-lg font-extrabold uppercase tracking-[0.12em] text-navy shadow-[0_20px_45px_-12px_rgba(185,155,92,0.7)] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-gold-soft active:translate-y-0 sm:w-auto"
        >
          Buy Now — {SITE.price}
        </a>
        <p className="mt-6 text-xs font-semibold uppercase tracking-[0.18em] text-ivory/50">
          Or order directly on WhatsApp
        </p>
        <a
          data-testid="offer-whatsapp-button"
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-full border-2 border-wa/60 px-8 py-4 text-sm font-bold uppercase tracking-[0.12em] text-[#7FE3AE] transition-all duration-300 hover:-translate-y-0.5 hover:bg-wa hover:text-[#063A2C] sm:w-auto"
        >
          <MessageCircle className="h-4 w-4" />
          Order on WhatsApp
        </a>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2.5" data-testid="offer-trust-strip">
          <span className="flex items-center gap-2 text-xs font-semibold text-ivory/60">
            <Truck className="h-4 w-4 text-gold" />
            Free shipping across India
          </span>
          <span className="flex items-center gap-2 text-xs font-semibold text-ivory/60">
            <ShieldCheck className="h-4 w-4 text-gold" />
            Secure payment via Razorpay — UPI & Cards
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Offer;
